<template>
    <div>
        <v-treeview
            :active.sync="active"
            :open.sync="open"
            :items="useLocalCache ? localCache : documentStore.sections"
            activatable
            transition
            dense
            item-key="id"
            :load-children="loadChildren"
            loading-icon="mdi-loading"
            @update:active="updateTreeview"
        >
            <template v-slot:label="{ item }">
                <div v-if="item.id < 0">
                    <v-icon left color="blue darken-2" v-if="item.section">mdi-square-rounded-badge-outline</v-icon>
                    <v-icon left color="amber" v-else>mdi-folder</v-icon>
                    {{ item.name}}
                </div>
                <div
                    v-else-if="item.section"
                    @dragover.prevent
                    @drop="$emit('onDrop', item)"
                >
                    <v-icon left color="red" v-if="item.inbox">mdi-inbox</v-icon>
                    <v-icon left color="blue darken-2" v-else-if="item.section">mdi-square-rounded-badge-outline</v-icon>
                    <v-icon left color="amber" v-else>mdi-folder</v-icon>
                    {{ item.name}}
                </div>
                <div
                    v-else
                    class="drop-zone"
                    @dragover.prevent
                    draggable="true"
                    @dragstart="$emit('onDragStart', item)"
                    @drop="$emit('onDrop', item)"
                >
                    <v-icon left color="red" v-if="item.inbox">mdi-inbox</v-icon>
                    <v-icon left color="blue darken-2" v-else-if="item.section">mdi-square-rounded-badge-outline</v-icon>
                    <v-icon left color="amber" v-else>mdi-folder</v-icon>
                    {{ item.name}}
                </div>
            </template>
        </v-treeview>
        <input type="hidden"/>
    </div>
</template>

<script>
import {useDocumentStore} from "@/stores/Edms/Document";
import {onMounted, ref, watch} from "vue";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    props: {
        value: Number,
        useLocalCache: Boolean,
    },
    setup(props, {emit}) {
        const documentStore = useDocumentStore();
        const {transformFilterValues} = useSharedMethod();

        const active = ref([]);
        const open = ref([]);
        const localCache = ref([]);


        function findAll() {
            axios.get('/documents', {
                params: transformFilterValues({
                    allRecords: true,
                    type: 'SECTION',
                    sortBy: 'id',
                    descending: false
                })
            }).then(response => {
                if (props.useLocalCache) {
                    localCache.value = response.data.elements;
                } else {
                    documentStore.setSections(response.data.elements);
                }
            });
        }

        function loadChildren(item) {
            return new Promise((resolve) => {
                axios.get('/documents', {
                    params: transformFilterValues({
                        allRecords: true,
                        parentId: item.id,
                        type: 'FOLDER',
                        sortBy: 'id',
                        descending: true
                    })
                }).then((response) => {
                    const children = response.data.elements
                    item.children = children
                    resolve(children)
                });
            })
        }

        function updateTreeview() {
            if (active.value.length > 0) {
                emit('input', active.value[0]);
                emit('select', active.value[0]);
            } else {
                emit('input', null);
            }
        }

        watch(() => props.value, () => {
            if (props.value !== null && props.value !== undefined) {
                active.value = [props.value];
            } else {
                active.value = [];
            }
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            documentStore,
            localCache,
            active,
            open,
            loadChildren,
            updateTreeview,
        }
    }
}
</script>

<style>
.v-treeview-node__root:hover {
    background-color: #f0f0f0; /* Set your desired hover color here */
    cursor: pointer;
}
</style>